module.exports = __webpack_public_path__ + "static/media/timeline-acao-infl.28cc26ef.svg";